export const ROOT = "/comparison";
export const COMPARISON = ROOT + "/:customerId/:tenderId/:responseIds";
export const NOT_FOUND = ROOT + "/*";
